export default __webpack_public_path__ + "static/media/k8s.a849ad96.png";